import styled, { css } from 'styled-components'

const Loader = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(5)};
  `}
`

export default {
  Loader,
}
